//Actions
import * as ACTIONS from "../actions";

// eslint-disable-next-line
const defaultScheme = ["#8884d8", "#83a6ed", "#8dd1e1", "#82ca9d", "#a4de6c", "#ffc658"];

const INITIAL_STATE = {
  mode: "light",
  scheme: defaultScheme
};

function appReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Generic Updates
    case ACTIONS.UPDATE_APP_ASPECT: {
      return { ...state, [`${action.aspect}`]: action.payload };
    }

    case ACTIONS.UPDATE_APP_REDUCER: {
      return { ...state, ...action.payload };
    }

    //Specific Updates

    default:
      return state;
  }
}

export default appReducer;
